import { EmailApiUsage } from '../types/emailApiUsage';
import { UsageStatsDto } from '../middle_tier/services/mako_api/dtos';

export function mapEmailApiUsage(usageStatsDto: UsageStatsDto) {
  return {
    emailApiSends: usageStatsDto.email_api_sends,
  } as EmailApiUsage;
}
